import React, { useMemo, useState } from "react";

const API_BASE = `${window.location.protocol}//${window.location.hostname}:5005/api`;

export default function FichajePanel() {
  const [employeeCode, setEmployeeCode] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const now = useMemo(() => new Date(), []);
  const [month, setMonth] = useState(String(now.getMonth() + 1).padStart(2, "0"));
  const [year, setYear] = useState(String(now.getFullYear()));

  async function doClock() {
    setLoading(true);
    setMsg("");
    try {
      const res = await fetch(`${API_BASE}/fichajes/clock`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ employeeCode: employeeCode.trim() }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.error || "Error fichando");

      setMsg(`✅ ${data.message} (${data.type}) ${new Date(data.timestamp).toLocaleString()}`);
    } catch (e) {
      setMsg(`❌ ${e.message}`);
    } finally {
      setLoading(false);
    }
  }

  function downloadPdf() {
    const code = employeeCode.trim();
    if (!code) {
      setMsg("❌ Escribe tu código de empleado.");
      return;
    }

    // abre descarga (stream)
    const url = `${API_BASE}/fichajes/monthly-pdf?employeeCode=${encodeURIComponent(code)}&month=${encodeURIComponent(month)}&year=${encodeURIComponent(year)}`;
    window.open(url, "_blank");
  }

  return (
    <div style={{ maxWidth: 520, margin: "0 auto", padding: 16 }}>
      <h2>Panel de Fichaje</h2>

      <label style={{ display: "block", marginTop: 12 }}>Código de empleado</label>
      <input
        value={employeeCode}
        onChange={(e) => setEmployeeCode(e.target.value)}
        placeholder="Ej: 1212"
        style={{ width: "100%", padding: 10, fontSize: 16 }}
      />

      <button
        onClick={doClock}
        disabled={loading || !employeeCode.trim()}
        style={{ width: "100%", marginTop: 12, padding: 12, fontSize: 16 }}
      >
        {loading ? "Fichando..." : "Fichar (Entrada/Salida)"}
      </button>

      <hr style={{ margin: "20px 0" }} />

      <h3>PDF mensual</h3>
      <div style={{ display: "flex", gap: 8 }}>
        <input value={month} onChange={(e) => setMonth(e.target.value)} style={{ flex: 1, padding: 10 }} placeholder="MM" />
        <input value={year} onChange={(e) => setYear(e.target.value)} style={{ flex: 2, padding: 10 }} placeholder="YYYY" />
      </div>

      <button onClick={downloadPdf} style={{ width: "100%", marginTop: 12, padding: 12, fontSize: 16 }}>
        Descargar PDF del mes
      </button>

      {msg && <p style={{ marginTop: 14 }}>{msg}</p>}
    </div>
  );
}
